import { useContext, useEffect } from "react";
import AllComponentsWrapper from "./all-components-wrapper.component";
import { languageChangerObject } from "./language";
import { LanguageContext } from "./contexts/language.context";
import { isItalianPath } from "./utils/hashNavigation";

function App() {
  const { romanianLanguage, setRomanianLanguage } = useContext(LanguageContext);

  useEffect(() => {
    const syncLanguageWithPath = () => {
      setRomanianLanguage(isItalianPath());
    };

    syncLanguageWithPath();
    window.addEventListener("popstate", syncLanguageWithPath);
    return () => window.removeEventListener("popstate", syncLanguageWithPath);
  }, [setRomanianLanguage]);

  useEffect(() => {
    const anchor = window.location.hash.replace("#", "");
    if (!anchor) return;
    setTimeout(() => {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }, [romanianLanguage]);

  const { russian, romanian } = languageChangerObject;

  return (
    <div className="App" style={{ backgroundColor: "#FBFAFE" }}>
      <AllComponentsWrapper
        props={romanianLanguage ? romanian : russian}
        lang={romanianLanguage ? "ro" : "en"}
      />
    </div>
  );
}

export default App;
